import { Component } from '@angular/core';

@Component({
    selector: 'rate-your-experience',
    templateUrl: './rate-your-experience.component.html',
    styleUrls: ['./rate-your-experience.component.scss']
})
export class RateYourExperienceComponent {

    constructor() { }

    ratingSelection: Number = 0;

    optionIsSelected: boolean = false;

    setRating(newRating: Number) {
        this.optionIsSelected = true;
        this.ratingSelection = newRating;
    }

}
